class Manifest
	def constructor
		data = {}

export const manifest = new Manifest
